import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export interface statusRevenueUploadFileParamsType {
  resultKey?: string;
  successCallback?: Function;
  errorCallback?: Function;
  id: string;
}

export default ({
  resultKey = 'statusRevenueUploadFileData',
  successCallback,
  errorCallback,
  id,
}: statusRevenueUploadFileParamsType) =>
  requestAsync({
    url: endpoints.getStatusRevenueUploadFileUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getStatusRevenueUploadFileUrl(id),
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
